import Vue from 'vue'
import { isNonEmptyArray, isNumber } from '@/utils'
import { Msgbox } from 'kf-component-vue'

import { getSpuIdsFromCMS, getPregantAuthStatus } from './service'

let childBirthSerivePackageList = []

// 服务待产包是否开启
let status = false

let pragnentInfo = {}

// spuId是否匹配
let isMatched = false
/**
 * @returns {Promise<Array>}
 */
export async function init() {
  // 只调用接口一次
  if (!isNonEmptyArray(childBirthSerivePackageList)) {
    const data = await getSpuIdsFromCMS()
    childBirthSerivePackageList = data.spuIds
    status = !!+data.status
  }
  return status ? childBirthSerivePackageList : []
}
/**
 * 是否命中设置的spuId
 */
export async function checkIfChildBirthSpuId(vueInstance) {
  const {
    params: { spuId }
  } = vueInstance.$route
  await init()
  if (childBirthSerivePackageList.find(x => +x === +spuId)) {
    isMatched = true
  }
  return status && isMatched
}
/**
 *
 * @param {Vue} vueInstance
 */
export async function hideUTag(vueInstance) {
  await checkIfChildBirthSpuId(vueInstance)
  if (!status || !isMatched) {
    // 为了更好的视觉交互体验 默认隐藏
    vueInstance.isHideUTag = false
  }
}

/**
 * 是否为高级认证孕妇
 * @param {Vue} vueInstance
 */
export async function isHighLevelPregant(vueInstance) {
  // 该活动已关闭
  if (!status) return true
  // spuId不匹配
  if (!isMatched) return true

  pragnentInfo = await getPregantAuthStatus()

  // 认证状态(0-未认证,1-待审核,2-审核未通过,3-已认证,4-认证已过期)
  if (![3, 4].includes(+pragnentInfo.pregantauthstatus)) {
    return new Promise(resolve => {
      Msgbox({
        title: '',
        message: '进行高级认证孕妇后享99元购买服务待产包',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        type: 'confirm',
        action(n) {
          location.href = pragnentInfo.pregantauthurl
          resolve(false)
        },
        cancel(msgbox) {
          resolve(false)
        }
      })
    })
  }
  return true
}
/**
 * 分享赚 去除服务待产包商品
 * @param {Vue} vueInstance
 */
export async function removeSpuIds(vueInstance) {
  const { spuList } = vueInstance
  let list = await init()
  // console.log(list)
  if (!isNonEmptyArray(list)) return
  let obj = {}
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(spuList)) {
    const tmp = value.filter(x => !list.includes(x.spuId))
    // console.log(key, value, tmp)
    if (isNonEmptyArray(tmp)) {
      obj[key] = tmp
    }
  }
  // console.log(obj)
  vueInstance.spuList = obj
}
